const prefix = '@drivex/customerTranslations';

const GET_ALL_TRANSLATIONS_SUCCESS = `${prefix}/GET_ALL_TRANSLATIONS_SUCCESS`;
const SAVE_CUSTOMER_TRANSLATIONS_SUCCESS = `${prefix}/SAVE_CUSTOMER_TRANSLATIONS_SUCCESS`;

export default {
  GET_ALL_TRANSLATIONS_SUCCESS,
  SAVE_CUSTOMER_TRANSLATIONS_SUCCESS,
};
